import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./index.css";
import config from "./config/config";

// Import components
import TopHeader from "./components/TopHeader";
import DynamicNavbar from "./components/DynamicNavbar";
import HomePage from "./components/HomePage";
import AboutUsPage from "./components/AboutUsPage";
import OptimizingPage from "./components/OptimizingPage";
import Page from "./components/Page";
import ContactUsPage from "./components/ContactUsPage";
import CareersPage from "./components/CareersPage";
import Dashboard from "./components/Dashboard";
import Footer from "./components/Footer";

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Admin Dashboard Route - No header/footer */}
          <Route path="/admin/*" element={<Dashboard />} />

          {/* Regular site routes with header/footer */}
          <Route
            path="/*"
            element={
              <>
                <TopHeader />
                <DynamicNavbar />
                <Routes>
                  {/* Main Pages */}
                  <Route path="/" element={<HomePage />} />
                  <Route path="/home" element={<HomePage />} />
                  <Route path="/about-us" element={<AboutUsPage />} />
                  <Route path="/contact-us" element={<ContactUsPage />} />
                  <Route path="/careers" element={<CareersPage />} />
                  
                  {/* Dynamic Pages */}
                  <Route path="/optimizing" element={<OptimizingPage />} />
                  <Route path="/page" element={<Page />} />
                  <Route path="/page/:slug" element={<Page />} />
                  <Route path="/page/:navType" element={<Page />} />
                  <Route path="/page/:navType/:subCategory" element={<Page />} />
                  
                  {/* Manufacturing Routes */}
                  <Route path="/manufacturing" element={<Page />} />
                  <Route path="/manufacturing/:category" element={<Page />} />
                  <Route path="/manufacturing/:category/:subcategory" element={<Page />} />
                  
                  {/* Sourcing Routes */}
                  <Route path="/sourcing" element={<Page />} />
                  <Route path="/sourcing/:category" element={<Page />} />
                  <Route path="/sourcing/:category/:subcategory" element={<Page />} />
                  
                  {/* Services Routes */}
                  <Route path="/services" element={<Page />} />
                  <Route path="/services/:service" element={<Page />} />
                  
                  {/* Products Routes */}
                  <Route path="/products" element={<Page />} />
                  <Route path="/products/:product" element={<Page />} />
                  
                  {/* Resources Routes */}
                  <Route path="/resources" element={<Page />} />
                  <Route path="/resources/:resource" element={<Page />} />
                  
                  {/* Projects Routes */}
                  <Route path="/projects" element={<Page />} />
                  <Route path="/projects/:project" element={<Page />} />
                  
                  {/* Catch-all route for 404 */}
                  <Route path="*" element={<HomePage />} />
                </Routes>
                <Footer />
              </>
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
